import { render } from "./profileImageAndQuestions.vue?vue&type=template&id=141227be&scoped=true&ts=true"
import script from "./profileImageAndQuestions.vue?vue&type=script&lang=ts"
export * from "./profileImageAndQuestions.vue?vue&type=script&lang=ts"

import "./profileImageAndQuestions.vue?vue&type=style&index=0&id=141227be&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-141227be"]])

export default __exports__